import { Button, Col, Popover, Row, Tooltip } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import {
  CASHLESS_DOWNLOAD_INFO,
  CASHLESS_FORM_CONSTANTS,
  DRAFT_CHANGE_STATUSES,
  INVENTROY_CONSTANTS,
  NEW_ADMISSION_DOWNLOAD_ACTIONS,
  POPOVER_DOWNLOAD_CONTENT,
  authFeatureConstants,
} from '../../../../../../shared/constants/commonConstants';
import {
  draftSequence, ERROR, ERROR_MODAL, ID_CARD_TYPE, DRAFTSTATUS_TO_INDEX_MAP,
  MISSING_VALUE_ERROR,
} from '../../../../../../shared/constants/crmConstants';
import { RootState } from '../../../../../../store';
import { saveDraftData, updateSaveDraftStatus } from '../../../../../../store/actions/savedDraftAction';
import { NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import { PayerInitialState } from '../../../../../../store/models/payerListModel';
import {
  convertToISOStrings,
  customGTMEvent,
  findKeyValuePairInsurerName,
  getCurrentUtcTime,
  getDoctorWithSignature,
  getDraftKeyFromStatus,
  getIsPageNameEdit,
  getIsPageNameEditDischarge,
  getIsPageNameNewAdmission,
  getIsPageNameReconsider,
  getUploadingFile,
  isBenefSuccess,
  isValidStayLength,
} from '../../../service/crmUtils';
import {
  setAdmissionForm,
  setHealthCardType,
  setGetHealthIdCard,
  downloadClaimPDF,
} from '../../../../../../store/actions/newAdmissionAction';
import { canActivate, centeredNotification, isDigitizationFeatureEnabled, mapClaimPdfData } from '../../../../../../utils/utility';
import { findIndex, isArray, isEmpty } from 'lodash';
import ApplicationDetail from '../../../../../../shared/services/applicationDetail.service';
import FormButtonDropDown from '../../../../../../shared/components/crmFormElement/FormButtonDropDown/FormButtonDropDown';
import { ReactComponent as DownloadIcon } from '../../../../../../assets/images/svg/i_download.svg';
import { HospitalState } from '../../../../../../store/models/hospitalModel';
import { ReactComponent as DraftIcon } from '../../../../../../assets/images/svg/Save-to-draft.svg';
import { ReactComponent as HisDownloadIcon } from '../../../../../../assets/images/svg/Download_HIS.svg';
import { ReactComponent as HisDisabledDownloadIcon } from '../../../../../../assets/images/svg/Disabled_Download_Icon.svg';
import { NHCXState } from '../../../../../../store/models/nhcxModel';

const LeftHeaderCtaAction = (props: any): ReactElement => {
  const { payer } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const { form, detailNav, isFormChanged, selectedSearchOption, buddhimedForm } = props;
  const history = useHistory();
  const isEdit = getIsPageNameEdit(history.location.pathname);
  const isEditDischarge = getIsPageNameEditDischarge(history?.location?.pathname);
  const isEditReconsider = getIsPageNameReconsider(history?.location?.pathname);
  const [isSavingDraft, setSavingDraft] = useState(false);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isMouseEntered, setIsMouseEntered] = useState(false);
  const { DRAFT_INITILIZING, DRAFT_SAVED } = DRAFT_CHANGE_STATUSES;
  const { draftCurrentStatus } = useSelector((state: RootState): any => state.savedDraft);
  const location = useLocation();
  const appService = ApplicationDetail.instance;
  const hospitalDetails = appService.getHospitalDetail();
  const userDetails = appService.getUserDetail();
  const { newAdmission: { adhaarVerified, nameAdhaarVerified, pltMappedValue, searchType,
    selectedOption, panNoVerified, dlVerified, voterIDVerified, panVerified, submitDisabled, claimDetailBackup } }:
    any = useSelector((state: RootState):
      RootState => state);
  const {
    admissionFormVal,
    selectedTab,
    uploadedFiles,
    nonAvailableClassification,
    selectedBeneficiaryDetail,
    isShowAdmissionForm,
    selectedPackage,
    existingClaimError,
    selectedCenter,
    admissionFormType,
    additionalAdmissionInfo,
    hospitalOtherRoomType,
    isBeneficiarySelected,
    isAbhaVerified,
    selectedDiscrepency,
    nonSelectedDiscrepency,
    selectedFiles,
    classificationArray,
    showProbability,
    mappedAilmentValues,
    memberSearchId,
    memberId: memberIdEntered,
    percentageNameMatch,
    govtSchemeUrn,
    selectedHISFiles,
    updatedVisibleLetters,
    selectedDoctorList,
    consentOptionStyle,
    patientSignature,
    patientConsentProceedClicked,
    consentOption,
    consentDateTime,
    isArtemis,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { claimDetails, isCashlessSubmit, isArtemisClaim } =
    useSelector((state: RootState): any => state.admissionDetails) || {};
  const { isDischargeContestCTA } = claimDetails || {};
  const { isDraftBtnClicked } = useSelector((state: RootState): any => state.selectedInPatientDetail);
  const { isHISClaim }: any = useSelector((state: RootState): HospitalState => state.hospital);
  const dispatch = useDispatch();
  const isPageNameNewAdmission = getIsPageNameNewAdmission(location.pathname);
  const {
    lookUp,
    payerLookUp,
    payerList: { payer: selectedPayer },
  } = useSelector((state: RootState): RootState => state);
  const { uniqueIdentifier } = selectedPayer || {};
  const { selectedPatientDetail, hospitalSearchPatientDetails } = useSelector((state: RootState): any => state.hospital);
  const { selectedPolicyDetail } = useSelector((state: RootState): NHCXState => state.nhcx);
  const isPreAuthNewDesignEnabled = ApplicationDetail.instance.getIsPreAuthNewDesignEnabled();
  const { doctorList = [] } = payerLookUp?.[uniqueIdentifier] || {};
  const [isBenefSearchSuccess, setIsBenefSearchSuccess] = useState(false);

  useEffect((): any => {
    if (!isEmpty(claimDetails)) {
      const isSuccessBenefSearch = isBenefSuccess(claimDetails);
      setIsBenefSearchSuccess(isSuccessBenefSearch);
    }
  }, [ claimDetails]);

  const onSaveToDraft = (showModal: any = true): void => {
    const memberId = form.getFieldValue('memberId');
    const policyNo = form.getFieldValue('policyNumber');
    const employeeId = form?.getFieldValue('employeeId');
    const dateofAdmission = form.getFieldValue('dateOfAdmission');
    const multipayerLengthofStay = form?.getFieldValue('lengthOfStay') || [];
    const dateOfDischarge = form.getFieldValue('dateOfDischarge');
    const stayLength = form?.getFieldValue('stayLength');
    const fullName = form?.getFieldValue('fullName');
    const fileUploadRemarkValue = {
      ...buddhimedForm.getFieldsValue('fileUploadRemark'),
    };
    const newDraftFormValue =
      detailNav?.length > 0 &&
        detailNav[selectedTab]?.formKey
        ? {
          [detailNav[selectedTab].formKey]: form.getFieldsValue(),
        } : {
          'customerDetail': form.getFieldsValue(),
          'otherFormDetail': form.getFieldsValue(),
        };
    if (fullName && (memberId || policyNo || employeeId)) {
      const newFormValue = {
        ...admissionFormVal,
        ...newDraftFormValue,
      } as any;

      // remove partially uploaded files before submitting draft
      const partiallyUploadedFile = getUploadingFile(uploadedFiles);
      if (partiallyUploadedFile) {
        const partiallyUploadedFileIndex = findIndex(uploadedFiles, { uid: partiallyUploadedFile?.uid });
        if (partiallyUploadedFileIndex >= 0) {
          uploadedFiles.splice(partiallyUploadedFileIndex, 1);
        }
      }
      if (dateofAdmission || dateOfDischarge || isValidStayLength(stayLength)) {
        const stayLengthISO = convertToISOStrings(stayLength);
        newFormValue.treatmentDetail = {
          ...newFormValue.treatmentDetail,
          dateOfAdmission: stayLengthISO?.[0],
          dateOfDischarge: stayLengthISO?.[1],
          stayLength: stayLengthISO,
        };
      } else {
        if (multipayerLengthofStay || isValidStayLength(stayLength)) {
          const stayLengthISO = convertToISOStrings(stayLength);
          newFormValue.treatmentDetail = {
            ...newFormValue.treatmentDetail,
            dateOfAdmission: stayLengthISO?.[0],
            dateOfDischarge: stayLengthISO?.[1],
            stayLength: stayLengthISO,
          };
          newFormValue.customerDetail = {
            ...newFormValue.customerDetail,
            stayLength: stayLengthISO,
          };
          newFormValue.otherFormDetail = {
            ...newFormValue.otherFormDetail,
            stayLength: stayLengthISO,
          };
        }
      }
      const isNewBornCaseDraft = (isEdit || isEditDischarge || isEditReconsider) &&
        newFormValue?.customerDetail?.isNewBornCase === 'Yes';
      const panCardField = form?.getFieldValue('panNumber')?.toUpperCase();
      let storeObj: any = {
        draftKey: getDraftKeyFromStatus(
          claimDetails?.nextAllowStatus,
          DRAFTSTATUS_TO_INDEX_MAP,
          draftSequence, isDischargeContestCTA,
        ),
        newFormValue,
        uploadedFiles,
        modalFormValue: fileUploadRemarkValue || {},
        payer,
        selectedBeneficiaryDetail,
        selectedPackage,
        claimDetails,
        panCardField,
        searchType,
        pltMappedValue,
        hospitalOtherRoomType,
        nameMatch: nameAdhaarVerified,
        isVerified: adhaarVerified || panNoVerified || dlVerified || voterIDVerified,
        draftBenefSelected: isBeneficiarySelected || isBenefSearchSuccess,
        draftAbhaVerified: isAbhaVerified,
        selectedOption,
        panVerified,
        nonAvailableClassification,
        selectedDiscrepency,
        nonSelectedDiscrepency,
        selectedFiles,
        classificationArray,
        showProbability,
        additionalAdmissionInfo: {
          draftStartTime: additionalAdmissionInfo?.admissionStartTime || '',
          draftEndTime: getCurrentUtcTime(),
        },
        submitDisabled,
        selectedPatientDetail, // to save the details of HIS selected data in case of drafts
        selectedPolicyDetail,
        memberSearchId,
        memberIdEntered,
        percentageNameMatch,
        isNewBornCaseDraft,
        claimDetailBackup,
        govtSchemeUrn,
        isHISClaim,
        selectedHISFiles,
        hospitalSearchPatientDetails,
        updatedVisibleLetters,
        isArtemis: isArtemis || isArtemisClaim,
        selectedDoctorList,
        consentOptionStyle,
        patientSignature,
        patientConsentProceedClicked,
        consentOption,
        consentDateTime,
      };

      const courierStatus = storeObj?.claimDetails?.courierStatus;
      if (courierStatus) {
        if (isArray(courierStatus) && courierStatus.length === 0) {
          storeObj.claimDetails = {
            ...storeObj.claimDetails,
            courierStatus: '',
          };
        }
      }
      if (detailNav?.length && detailNav[selectedTab].formKey === 'billDetail') {
        storeObj.newFormValue = {
          ...storeObj.newFormValue,
          billDetail: form.getFieldsValue(),
        };
      }

      if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
        storeObj = {
          ...storeObj,
          providerId: selectedCenter?.providerId,
          providerName: selectedCenter?.providerName,
        };
      }

      const successHandler = (): void => {
        dispatch(updateSaveDraftStatus(DRAFT_SAVED));
        centeredNotification('Draft has saved successfully.', 'info');
        setSavingDraft(true);
      };

      const onErrorHandler = (): void => {
        dispatch(updateSaveDraftStatus(showModal ? ERROR_MODAL : ERROR));
      };

      setSavingDraft(true);
      const draftData = isArray(storeObj?.settlement) ? storeObj?.settlement[0] : storeObj;
      dispatch(saveDraftData(draftData, successHandler, onErrorHandler));
    } else {
      if (!fullName) {
        centeredNotification(MISSING_VALUE_ERROR.patientName, 'error');
      } else {
        centeredNotification(MISSING_VALUE_ERROR.memberId, 'error');
      }
    }
  };

  useEffect((): any => {
    if (draftCurrentStatus === DRAFT_INITILIZING) {
      onSaveToDraft(false);
    }
  }, [draftCurrentStatus]);

  const openIDCardModal = (cardType: string): any => {
    dispatch(setHealthCardType(cardType));
    dispatch(setGetHealthIdCard(true));
  };

  const onDownloadPDFClickHandler = (formType: string): void => {
    let newFormValue: any = admissionFormVal;
    let payload = {};
    if (detailNav?.length) {
      newFormValue = {
        ...newFormValue,
        ...{
          [detailNav[selectedTab].formKey]: form.getFieldsValue(),
        },
      };
    } else {
      newFormValue = {
        ...newFormValue,
        otherFormDetail: form.getFieldsValue(),
        customerDetail: form.getFieldsValue(),   // fix to prevent multipayer form from resetting with the initial admissionFormVal
      };
    }
    let insurerName = '';
    let insurerID = 0;
    if (formType === 'cashlessForm') {
      payerLookUp[uniqueIdentifier]?.insurerName?.map((insurer: any): void => {
        if (insurer.masterLookId === Number(newFormValue?.customerDetail?.insurerName)) {
          insurerName = insurer.name;
        }
      });
      const { maMasterId: insurerId } =
        findKeyValuePairInsurerName(payerLookUp[uniqueIdentifier]?.insurerName, 'name', (form?.getFieldsValue('insurerName')?.insurerName ||
          newFormValue?.customerDetail?.insurerName), true) ||
        findKeyValuePairInsurerName(payerLookUp[uniqueIdentifier]?.insurerName,
          'value', (form?.getFieldsValue('insurerName')?.insurerName ||
            newFormValue?.customerDetail?.insurerName), true) ||
        {};
      insurerID = insurerId;
    }
    const hospitalSeal = isDigitizationFeatureEnabled(appService?.getIsHospitalSealFeatureEnabled()) ?
      JSON?.parse(localStorage?.getItem(CASHLESS_FORM_CONSTANTS.HOSPITALSEAL) || '{}') : null;
    const doctorSignature = isDigitizationFeatureEnabled(appService?.getIsDoctorSignatureFeatureEnabled()) ?
      getDoctorWithSignature(selectedDoctorList, doctorList, form) : null;
    const patientSign = (isDigitizationFeatureEnabled(appService?.getIsPatientSignEnabled()) && patientConsentProceedClicked) ?
    JSON?.parse(localStorage?.getItem(INVENTROY_CONSTANTS.patient_signature) || '{}') : null;
    if (admissionFormType === '') {
      centeredNotification('Please choose any payer before downloading.');
    } else {
      payload =
        mapClaimPdfData(
          formType, hospitalDetails, newFormValue,
          userDetails, insurerName, hospitalOtherRoomType, payer, admissionFormType,
          lookUp, payerLookUp, insurerID, mappedAilmentValues, hospitalSeal?.guid, doctorSignature,
          patientSign?.guid,
        );
      dispatch(downloadClaimPDF(payload));
    }
    dispatch(setAdmissionForm(newFormValue));
    customGTMEvent({
      event: `Download ${formType}`,
    });
  };

  const creatAbha = (): any => {
    return (
      <Popover
        placement="bottom"
        title={<p className="popover-download">Create ABHA</p>} // You can customize the title
        content={
          <div className="popover-download-content">
            {(isPreAuthNewDesignEnabled)
              ? 'Click to create ABHA number test'
              : ''}
          </div>
        }
        trigger="hover"
      >
        <Col>
          <Button
            className={`${(isPreAuthNewDesignEnabled) ? 'borderless' : ''} ghost-primary-btn`}
            type="ghost"
            data-testid="health-id-card"
            onClick={(): any => openIDCardModal(ID_CARD_TYPE.HEALTH)}
          >
            {(isPreAuthNewDesignEnabled) ? 'ABHA' : 'Create ABHA'}
          </Button>
        </Col>
      </Popover>
    );
  };

  const showDraft = (): any => {
    return (
      <Popover
        placement="bottom"
        content={<p className="popover-download popover-draft-icon">Save to draft</p>}
        trigger="hover"
      >
        <Col>
          <Button
            className={`ghost-primary-btn ${isPreAuthNewDesignEnabled ? 'his-draft-icon' : ''}`}
            type="ghost"
            disabled={(draftCurrentStatus === DRAFT_SAVED && !isFormChanged) || existingClaimError?.isError}
            onClick={onSaveToDraft}
            loading={isSavingDraft}
            icon={isPreAuthNewDesignEnabled ? <DraftIcon /> : null}
            data-testid="save-to-draft"
          >
            {!isPreAuthNewDesignEnabled && 'Save to draft'}
          </Button>
        </Col>
      </Popover>
    );
  };

  const handleDropdownToggle = (visible: boolean): any => {
    setDropdownVisible(visible);
  };

  const showHisNewadmissionActionBtn = (): any => {
    return (
      !payer?.isClaimSubmissionDisabled &&
      <Row className="header-btn-container" justify="end">
        {((!isDraftBtnClicked ? selectedSearchOption : payer?.id !== 0) && isPreAuthNewDesignEnabled && isPageNameNewAdmission &&
          process.env.REACT_APP_HEALTH_ID_BUTTON_ENABLED === 'true') ?
          <Popover
            placement="bottom"
            title={<p className="popover-download">Create ABHA</p>} // You can customize the title
            content={
              <div className="popover-download-content">
                {(isPreAuthNewDesignEnabled && isPageNameNewAdmission)
                  ? 'Click to create ABHA number test'
                  : ''}
              </div>
            }
            trigger="hover"
          >
            <Col style={{ left: '18px' }}>
              <Button
                className={`${(isPreAuthNewDesignEnabled && isPageNameNewAdmission) ? 'borderless' : ''} ghost-primary-btn`}
                type="ghost"
                data-testid="health-id-card"
                onClick={(): any => openIDCardModal(ID_CARD_TYPE.HEALTH)}
              >
                {(isPreAuthNewDesignEnabled && isPageNameNewAdmission) ? 'ABHA' : 'Create ABHA'}
              </Button>
            </Col>
          </Popover>
          : (isPreAuthNewDesignEnabled && !isPageNameNewAdmission &&
            !(claimDetails?.isQuery || isCashlessSubmit)) && creatAbha()}
        {getIsPageNameNewAdmission(history?.location?.pathname) && (
          (isPreAuthNewDesignEnabled && (!isDraftBtnClicked ? selectedSearchOption : payer?.id !== 0)) ? (
            payer?.id === 0 ? (
              <Popover
                placement="bottom"
                title={<p className="popover-download">Download</p>}
                content={
                  <div
                    className="popover-download-content"
                    dangerouslySetInnerHTML={{ __html: POPOVER_DOWNLOAD_CONTENT }}
                  />
                }
                trigger="hover"
              >
                <Col className="text-right">
                  <FormButtonDropDown
                    detail={{
                      className: `ghost-primary-btn download-svg-icon ${payer?.id === 0 ? 'mouse-not-allowed' : ''}`,
                      buttonType: 'ghost',
                      isGhost: false,
                      Icon: isPreAuthNewDesignEnabled && payer?.id === 0 ? HisDisabledDownloadIcon : HisDownloadIcon,
                      disabled: payer?.id === 0,
                      iconClasses: payer?.id === 0,
                      hideLabel: true,
                      options: NEW_ADMISSION_DOWNLOAD_ACTIONS,
                      style: isPreAuthNewDesignEnabled ? { border: 'none' } : undefined,
                      onChange: onDownloadPDFClickHandler,
                      showbtnIcon: true,
                    }}
                  />
                </Col>
              </Popover>
            ) : (
              <Popover
                placement="bottom"
                title={<p className="popover-download">Download</p>}
                content={
                  <div className="popover-download-content"
                    dangerouslySetInnerHTML={{ __html: CASHLESS_DOWNLOAD_INFO }}
                  />
                }
                trigger="hover"
                visible={!isDropdownVisible && isMouseEntered}
              >
                <div
                  onMouseEnter={(): any => {
                    setIsMouseEntered(true);
                  }}

                  onMouseLeave={(): any => {
                    setIsMouseEntered(false);
                  }}
                >
                  <Col className="text-right">
                    <FormButtonDropDown
                      detail={{
                        className: `ghost-primary-btn ${isPreAuthNewDesignEnabled ? 'download-svg-icon' : ''}`,
                        buttonType: 'ghost',
                        isGhost: false,
                        Icon: isPreAuthNewDesignEnabled ? HisDownloadIcon : DownloadIcon,
                        iconClasses: payer?.id === 0,
                        disabled: payer?.id === 0,
                        hideLabel: true,
                        options: NEW_ADMISSION_DOWNLOAD_ACTIONS,
                        style: isPreAuthNewDesignEnabled ? { border: 'none' } : undefined,
                        onDropdownToggle: (visible: boolean): any => handleDropdownToggle(visible),
                        onChange: onDownloadPDFClickHandler,
                        showbtnIcon: true,
                      }}
                    />
                  </Col>
                </div>
              </Popover>
            )
          ) : (!isPreAuthNewDesignEnabled &&
            <Tooltip title={payer?.id === 0 ?
              'Select a payer to download cashless form, checklist form, acknowledgement letter' : ''}>
              <Col className="text-right">
                <FormButtonDropDown
                  detail={{
                    className: 'ghost-primary-btn text-right',
                    buttonType: 'ghost',
                    isGhost: false,
                    key: 'Download',
                    Icon: DownloadIcon,
                    iconClasses: payer?.id === 0 ? 'disabled-icon' : 'fill-primary',
                    disabled: payer?.id === 0,
                    hideLabel: true,
                    options: NEW_ADMISSION_DOWNLOAD_ACTIONS,
                    onChange: onDownloadPDFClickHandler,
                  }}
                />
              </Col>
            </Tooltip>
          )
        )}
        {isShowAdmissionForm &&
          (getIsPageNameNewAdmission(history.location.pathname)
            || getIsPageNameEdit(history?.location?.pathname)
            || getIsPageNameEditDischarge(history?.location?.pathname) || getIsPageNameReconsider(history?.location?.pathname)) && (
            (isPreAuthNewDesignEnabled && (!isDraftBtnClicked ? selectedSearchOption : payer?.id !== 0)
              && payer?.id !== 0 && isPageNameNewAdmission) ? (
              <Popover
                placement="bottom"
                content={<p className="popover-download popover-draft-icon">Save to draft</p>}
                trigger="hover"
              >
                <Col>
                  <Button
                    className={`ghost-primary-btn ${isPreAuthNewDesignEnabled ? 'his-draft-icon' : ''}`}
                    type="ghost"
                    disabled={(draftCurrentStatus === DRAFT_SAVED && !isFormChanged) || existingClaimError?.isError}
                    onClick={onSaveToDraft}
                    loading={isSavingDraft}
                    icon={isPreAuthNewDesignEnabled ? <DraftIcon /> : null}
                    data-testid="save-to-draft"
                  >
                    {!isPreAuthNewDesignEnabled && 'Save to draft'}
                  </Button>
                </Col>
              </Popover>
            ) : !isPreAuthNewDesignEnabled ? showDraft() : (isPreAuthNewDesignEnabled && getIsPageNameEdit(history?.location?.pathname)
              || getIsPageNameEditDischarge(history?.location?.pathname) || getIsPageNameReconsider(history?.location?.pathname)) ?
              showDraft() : null
          )
        }

        {(!isPreAuthNewDesignEnabled && process.env.REACT_APP_HEALTH_ID_BUTTON_ENABLED === 'true') &&
          !(claimDetails?.isQuery || isCashlessSubmit) ?
          creatAbha() : null}
      </Row>
    );
  };

  return (
    <React.Fragment>

      {showHisNewadmissionActionBtn()}
    </React.Fragment>
  );
};

export default withRouter(LeftHeaderCtaAction);
